"use client";

import { useEffect, useRef } from "react";
import { toast } from "sonner";

import { authClient, googleOneTapClientId } from "@/lib/auth-client";

export function GoogleOneTap() {
  const triggered = useRef(false);

  useEffect(() => {
    if (triggered.current) {
      return;
    }
    if (!googleOneTapClientId) {
      return;
    }

    triggered.current = true;

    void authClient
      .oneTap({
        fetchOptions: {
          onSuccess: () => {
            window.location.assign("/");
          },
          onError: () => {
            toast.error("Couldn't sign you in with Google. Try again.");
          },
        },
      })
      .catch(() => {
        // Swallow; Better Auth's onError already surfaced the toast for the
        // verification path; thrown errors here are rare init-time issues
        // (script blocked, no Google session) and don't warrant interrupting
        // the visitor.
      });
  }, []);

  return null;
}
